// should match account-settings.go https://git.autodesk.com/tandem/dt-server/blob/master/src/autodesk.com/double-trouble/btstore/account-settings.go#L53-L64
export const Type = Object.freeze({
  free: 'free',
  standard: 'standard',
  token: 'token',
  vdcbundle: 'vdcbundle',
  aec: 'aec',
  capacity: 'capacity',
  freemium: 'freemium',
  enterprise: 'enterprise',
  essentials: 'essentials'
});

export const CapacityConsumingTypes = Object.freeze([Type.capacity, Type.freemium, Type.essentials]);

export const CapacityBasedTypes = Object.freeze([Type.capacity, Type.freemium, Type.enterprise, Type.essentials]);

export const TokenSpendingTypes = Object.freeze([Type.token, Type.enterprise]);

const years1min5 = Object.freeze({ retentionPeriod: 365, frequency: 5 * 60 * 1000 });
const days14min5 = Object.freeze({ retentionPeriod: 14, frequency: 5 * 60 * 1000 });
const days14min1 = Object.freeze({ retentionPeriod: 14, frequency: 60 * 1000 });
const years3min1 = Object.freeze({ retentionPeriod: 3 * 365, frequency: 60 * 1000 });
export function GetCapacityDefaults(accountType) {
  switch (accountType) {
    case Type.capacity:
    case Type.enterprise:
    case Type.essentials:
      return years1min5;
    case Type.freemium:
      return days14min5;
    // For legacy accounts, see btstore.GetEventSpan in dt-server.
    case Type.standard:
    case Type.token:
      return years3min1;
    default:
      return days14min1;
  }
}

export default {
  CapacityConsumingTypes,
  CapacityBasedTypes,
  GetCapacityDefaults,
  TokenSpendingTypes,
  Type
};